import PortfolioLayout from "./portfolio_layout";
const PortfolioPage = () => {
  return (
      <PortfolioLayout />
  );
};

export default PortfolioPage;